import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosReasonSelectModalComponent } from './pos-reason-select-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [PosReasonSelectModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PosReasonSelectModalModule { }
